export const UPLOAD_TOO_LARGE_WARNING = "Upload failed because the file is too large.";

const UPLOAD_REQUEST_ID_PREFIX = "FILE_UPLOAD:";

export function createUploadRequestId(internalId: number): string {
  return UPLOAD_REQUEST_ID_PREFIX + internalId;
}

export function getUploadInternalId(requestId: unknown): number | undefined {
  if (typeof requestId !== "string" || requestId.indexOf(UPLOAD_REQUEST_ID_PREFIX) !== 0) {
    return undefined;
  }

  const internalId = Number(requestId.slice(UPLOAD_REQUEST_ID_PREFIX.length));
  return Number.isSafeInteger(internalId) && internalId > 0 ? internalId : undefined;
}

export function isUploadTooLargeError(error: any): boolean {
  if (error?.response?.status === 413 || error?.httpStatus === 413 || error?.status === 413
    || error?.cause?.response?.status === 413) {
    return true;
  }

  const details = [
    error,
    error?.message,
    error?.errorMessage,
    error?.errorCode,
    error?.response?.statusText,
    error?.response?.data,
    error?.cause?.message,
    error?.cause?.response?.statusText,
    error?.cause?.response?.data,
  ]
    .filter((value) => typeof value === "string")
    .join(" ");

  return /(?:file|upload|payload|entity|request(?: body)?)\s+(?:is\s+)?too\s+large|maximum\s+upload\s+size|entitytoolarge|payloadtoolarge|requestentitytoolarge/i.test(details);
}

export function uploadFailureMessage(error: any, fallback: string): string {
  return isUploadTooLargeError(error) ? UPLOAD_TOO_LARGE_WARNING : fallback;
}



// WEBPACK FOOTER //
// ./src/services/file/upload.errors.ts